import { LABOR_MIX_DATA, type LaborMixDatum } from "./laborMixData"

// Returns the row for the requested year, falling back to the nearest
// in-bounds row when the timeline runs past either end of the dataset.
export const getLaborDatumForYear = (year: number): LaborMixDatum => {
  const exact = LABOR_MIX_DATA.find((datum) => datum.year === year)
  if (exact) return exact
  return getClampedDatum(year)
}

// Clamp the year into the dataset range and look up that row instead.
const getClampedDatum = (year: number): LaborMixDatum => {
  const minYear = LABOR_MIX_DATA[0].year
  const maxYear = LABOR_MIX_DATA[LABOR_MIX_DATA.length - 1].year
  const clampedYear = Math.max(minYear, Math.min(maxYear, year))
  return LABOR_MIX_DATA.find((datum) => datum.year === clampedYear) ?? LABOR_MIX_DATA[0]
}

